export const VIDEOS = [
  {
    "title": "Happy à l'asinerie",
    "content": "",
    "type": "youtube",
    "url": "Iwrxq-2f6Rk",
    "place": "12 Rue du Moulin, 79210 Saint-Georges-de-Rex",
    "date": 1441756800
  },
  {
    "title": "Generick à l'asinerie",
    "content": "",
    "type": "youtube",
    "url": "zG_5IrFD_WE",
    "place": "12 Rue du Moulin, 79210 Saint-Georges-de-Rex",
    "date": 1441756800
  },
  {
    "title": "Panic sur l'Ile de Ré",
    "content": "Sortie d'église d'un mariage fort sympathique sur l'Ile de Ré",
    "type": "youtube",
    "url": "Yqk8gbf-lpI",
    "place": "21 Cours Dechezeau, 17410 Saint-Martin-de-Ré",
    "date": 1434326400
  },
  {
    "title": "Pink en centre-ville",
    "content": "",
    "type": "youtube",
    "url": "WgMojrqkjEc",
    "place": "86000 Poitiers",
    "date": 1423958400
  },
  {
    "title": "Croco en répète",
    "content": "",
    "type": "youtube",
    "url": "xJH8I7wwa-U",
    "place": "86000 Poitiers",
    "date": 1423958400
  },
  {
    "title": "Isio 4 au Pince Oreille",
    "content": "",
    "type": "youtube",
    "url": "RCwzi6_Z3uI",
    "place": "11 Rue des 3 Rois, 86000 Poitiers",
    "date": 1399507200
  },
  {
    "title": "Perry au Maraisthon 2013",
    "content": "",
    "type": "youtube",
    "url": "fKBZ0UE5_v0",
    "place": "79510 Coulon",
    "date": 1371385138
  },
  {
    "title": "Poker Fesses au Maraisthon 2013",
    "content": "",
    "type": "youtube",
    "url": "v6mJeUxHszs",
    "place": "79510 Coulon",
    "date": 1371385138
  },
  {
    "title": "Rita au Maraisthon 2013",
    "content": "",
    "type": "youtube",
    "url": "cvhyb_W0PhY",
    "place": "79510 Coulon",
    "date": 1371385138
  },
  {
    "title": "Hot Stuff à Thoissey",
    "content": "",
    "type": "youtube",
    "url": "YGUASGrxK0c",
    "place": "11 Rue du Beaujolais, 01140 Thoissey",
    "date": 1375574400
  },
  {
    "title": "Sheila à Thoissey",
    "content": "",
    "type": "youtube",
    "url": "RBeTE7drqmE",
    "place": "01140 Thoissey",
    "date": 1438560000
  },
  {
    "title": "O'Pressing à Thoissey",
    "content": "",
    "type": "youtube",
    "url": "cI7WTUPEbPs",
    "place": "01140 Thoissey",
    "date": 1438560000
  }
]



/** WEBPACK FOOTER **
 ** ./src/data/videos.data.js
 **/